var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUTurnLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40851 20.7526C6.99287 21.1162 6.36111 21.0741 5.99743 20.6585L2.49742 16.6585C2.16753 16.2815 2.16753 15.7185 2.49742 15.3415L5.99743 11.3415C6.36111 10.9258 6.99287 10.8837 7.40851 11.2474C7.82414 11.6111 7.86626 12.2429 7.50258 12.6585L5.45377 15H15.25C18.0114 15 20.25 12.7614 20.25 10C20.25 7.23857 18.0114 5 15.25 5H6.75C6.19772 5 5.75 4.55228 5.75 4C5.75 3.44771 6.19772 3 6.75 3H15.25C19.116 3 22.25 6.134 22.25 10C22.25 13.866 19.116 17 15.25 17H5.45377L7.50258 19.3415C7.86626 19.7571 7.82414 20.3889 7.40851 20.7526Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUTurnLeft);
export default __webpack_public_path__ + "static/media/arrow_u_turn_left.2fd604082db3392aed39d0424b7c2581.svg";
export { ForwardRef as ReactComponent };